module.exports = __webpack_public_path__ + "img/02d_marketing.fe87dcde.jpg";